import "./SinteredWireMeshSelectionGuide.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import SinteredHero from "./sections/SinteredHero";
import MeshGuide from "./sections/MeshGuide";
import RelatedArticles from "./sections/RelatedArticles";
import QuoteCTA from "./sections/QuoteCTA";
import Footer from "@/reusable_sections/Footer";
export default function SinteredWireMeshSelectionGuidePage() {
  return <div>
      <Header />
      <PageBreadcrumb page="SinteredWireMeshSelectionGuide" />
      <SinteredHero />
      <MeshGuide />
      <RelatedArticles />
      <QuoteCTA />
      <Footer />
    </div>;
}